"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailContext = void 0;
const react_1 = require("react");
exports.DetailContext = react_1.createContext(undefined);
//# sourceMappingURL=detail-context.js.map